import React, { useState } from "react";
import styles from '../styles/defaultCard.module.scss'
import Icon from "@/wmCompoments/Icon";
import Toast from "@/wmCompoments/toast";
import { useCardList, useDecryptData, useDeleteCard } from "@/api/request";
import { getWalletLocalConfig } from "@/utils/wallet";
import ErrorMessageDialog from "@/antComponent/errorMessageDialog";
import DeleteConfirm from "../dialog/deleteConfirm";
import DesensitzeData from "../dialog/desensitzeData";
import { useCardNumberStorage } from "@/provides/cardNumberProvider";
import SpinLoading from "@/wmCompoments/spinLoading";
import { useTranslation } from "react-i18next";

interface Props {
    data: any
    code: any
}
const DefaultCard = (props: Props) => {
    const { data, code } = props
    const { t } = useTranslation('accountManagement')
    const handleCopy = (v) => {
        if (ut.copyBoard(v)) {
            Toast.show(t('copySuccess'))
        }
    }

    const conifg = getWalletLocalConfig(code);
    const [visible, setVisible] = useState(false)
    const { trigger } = useDeleteCard(conifg?.delApi)
    const { mutate } = useCardList(conifg?.api)
    const [eyeSwitch, setEyeSwitch] = useState(false)
    const [desensitzeVisible, setDesensitzeVisible] = useState(false)
    const { trigger: triggerDecrypt } = useDecryptData()
    const { setItem, data: cardData } = useCardNumberStorage()
    const [eyeloading, setEyeloading] = useState(false)

    const onClickDelete = () => {
        setVisible(true)
    }
    const handleDelete = async () => {
        try {
            await trigger({
                id: data?.id,
                /**暂不清楚该字段含义 */
                twoPassword: ''
            })
            await mutate()
        } catch (error: any) {
            ErrorMessageDialog(error?.message ?? JSON.stringify(error))
        }
    }

    const handleDecrypt = async () => {
        if (eyeSwitch) {
            setEyeSwitch(false)
            return
        }
        if (!window.isVerifyEencryption) {
            setDesensitzeVisible(true)
        } else {
            if (cardData?.[data?.id]) {
                setEyeSwitch(true)
            } else {
                try {
                    setEyeloading(true)
                    const decrypt = await triggerDecrypt({
                        code: '',
                        encryptedString: '',
                        fingerprint: data?.[conifg?.fingerprint ?? '']
                    })
                    setItem(data?.id, decrypt.data)
                    setEyeSwitch(true)
                } catch (error: any) {
                    Toast.show(error?.message ?? JSON.stringify(error))
                } finally {
                    setEyeloading(false)
                }
            }
        }
    }

    return <div className={styles.item}>
        <div className={styles.warpper}>
            <div className={styles.top}>
                <Icon name={'icon-crypto-card'} className={styles.cryptoIcon} />
                <span>{data?.alias}</span>
                <Icon name={'icon-general-delete'} className={styles.iconDelete} onClick={() => onClickDelete()} />
            </div>
            <div className={styles.bottom}>
                <div>
                    <span>{t('walletAddress')}</span>
                    {eyeloading ? <SpinLoading /> : <Icon name={'icon-user-eye-off'} className={styles.iconEye} onClick={() => {
                        handleDecrypt()
                    }} />}
                </div>
                <div>
                    <span>{eyeSwitch ? cardData?.[data?.id] : data?.address}</span>
                    <div className={styles.copyWarpper} onClick={() => {
                        handleCopy(eyeSwitch ? cardData?.[data?.id] : data?.address)
                    }}>
                        <Icon name={'icon-games-copy'} />
                        <span>{t('copy')}</span>
                    </div>
                </div>
            </div>
        </div>
        <DeleteConfirm visible={visible} onClose={() => {
            setVisible(false)
        }}
            onSubmit={handleDelete}
        />

        <DesensitzeData visible={desensitzeVisible} onClose={() => {
            setDesensitzeVisible(false)
        }} fingerprint={data?.[conifg?.fingerprint ?? '']} onSuccess={(v) => {
            setItem(data?.id, v)
            setEyeSwitch(true)
        }} />
    </div>
}

export default DefaultCard